import { writable } from 'svelte/store';
import { getData } from '../helpers.js';

// Shared user info for the account dropdown (and eventually the dashboard).
// subscription-type is NOT fetched here — reuse subscriptionType from
// src/stores/integrations.js to avoid a duplicate request.
export const username = writable('');
export const accountValid = writable(true);
export const lifetimeValid = writable(false);
export const accountValidityError = writable('');
export const periodDownloads = writable(null);
export const userInfoLoaded = writable(false);

let fetchStarted = false;

// Fetches user info once per page load; safe to call from every consumer.
export function loadUserInfo() {
	if (fetchStarted) return;
	fetchStarted = true;

	const usernamePromise = getData('user/get-username')
		.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				username.set(ret_json.username);
			}
		});

	const validityPromise = getData('user/account-validity')
		.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				accountValid.set(ret_json.valid);
				if (ret_json.valid) {
					lifetimeValid.set(ret_json.lifetime_valid);
				} else {
					accountValidityError.set(ret_json.error_text);
				}
			}
		});

	const downloadsPromise = getData('user/get-period-files-downloaded')
		.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				periodDownloads.set(ret_json.count);
			}
		});

	Promise.allSettled([usernamePromise, validityPromise, downloadsPromise]).then(() => {
		userInfoLoaded.set(true);
	});
}
